import styled from 'styled-components';
import { BaseDivHomePage } from '../styles';
import { hextoRgba } from '@/main/services/utils';
import { Link } from 'react-router-dom';

export const AreaHeader = styled.div`
  position: fixed;
  top: 1rem;
  left: 0;
  width: 100%;
  z-index: 100;
`;

export const ContainerNavBar = styled(BaseDivHomePage)`
  /*  */
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 0 1rem;
    .show-only-desktop {
      display: none;
    }
  }
`;
export const NavBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.4rem;
  padding: 1rem;
  height: 80px;
  background: ${({ theme }) => hextoRgba(theme.pantone657C, 0.8)};
  box-shadow: 0px 0px 10px 0px
    ${({ theme }) => hextoRgba(theme.pantone657C, 0.8)};
  border-radius: 8px;
  backdrop-filter: blur(1px);
  margin: 0 auto;
`;

export const Logo = styled.img`
  width: 100%;
  max-width: 120px;
`;

export const SubPage = styled.span`
  color: ${({ theme }) => theme.white};

  :hover {
    filter: brightness(0.5);
  }
`;

export const Login = styled(Link)`
  &&& {
    background-color: ${({ theme }) => theme.pantone2726C};
    padding: 1rem 2rem;
    text-align: center;
    border-radius: 16px;
    color: ${({ theme }) => theme.white};
    cursor: pointer;
    transition: ease-out 0.2s;

    :hover {
      background-color: ${({ theme }) => theme.pantone2727C};
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
      width: 100%;
    }
  }
`;

export const MenuMobile = styled.div`
  display: none;

  .MuiSvgIcon-root {
    color: ${({ theme }) => theme.white};
    font-size: 2rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: block;
    margin: 0 0 0 auto;
  }
`;

